import { render, staticRenderFns } from "./filtro_agendamento.vue?vue&type=template&id=2b15ea10"
import script from "./filtro_agendamento.vue?vue&type=script&lang=js"
export * from "./filtro_agendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports